export enum BowtieDisplayMode {
  fullscreen,
  searchResult
}
